module.exports = __webpack_public_path__ + "static/olusoji-980ebb084c00d2afdcc7253c92a87781.png";